import React, { useState } from "react";

const Enquiry = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    days: "",
    pickup: "",
    drop: "",
    cab: "Swift Dzire (4+1 Seater)",
    date: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Construct WhatsApp Message
    const whatsappMessage = `
*New Enquiry -  Urbania on Rent in Pune*

👤 Name: ${formData.name}
📞 Phone: ${formData.phone}
✉️ Email: ${formData.email}
📍 Pickup: ${formData.pickup}
📍 Drop: ${formData.drop}
🚌 Cab: ${formData.cab}
🗓 Date of Journey: ${formData.date}
⏳ Days: ${formData.days}
💬 Message: ${formData.message}
    `;

    // WhatsApp API Link
    const whatsappUrl = `https://wa.me/9209423113?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    window.open(whatsappUrl, "_blank");
  };

  return (


<>


<div
      className="breadcumb-wrapper"
      
      data-overlay="black"
      data-opacity="3"
    >
      <div className="container">
        <div className="breadcumb-content text-center">
          <h1 className="breadcumb-title">Enquiry</h1>
        </div>
      </div>
    </div>


 











    <section className="enquiry-section">
      <div className="enquiry-wrapper">
        <div className="enquiry-title">
          <h2>Send Us A Message</h2>
          <p>Fill out the form and we’ll reply via WhatsApp</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <input
              type="text"
              name="name"
              placeholder="Your Full Name"
              value={formData.name}
              onChange={handleChange}
              required
               className="borderr"
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
               className="borderr"
            />
          </div>

          <div className="form-row">
            <input
              type="text"
              name="phone"
              placeholder="Your Phone"
              value={formData.phone}
              onChange={handleChange}
              required
               className="borderr"
            />
            <input
              type="number"
              name="days"
              placeholder="Number of Days"
              
              value={formData.days}
              onChange={handleChange}
               className="borderr"
              required
               
              
            />
          </div>

          <div className="form-row ">
            <input
              type="text"
              name="pickup"
              placeholder="Pick Up Point"
              value={formData.pickup}
              onChange={handleChange}
              className="borderr"
            />
            <input
              type="text"
              name="drop"
              placeholder="Drop Location"
              value={formData.drop}
              onChange={handleChange}
               className="borderr"
            />
          </div>

          <div className="form-row">
            <select
              name="cab"
               className="borderr"
              value={formData.cab}
              onChange={handleChange}
              
            >
           
              <option>10 Seater Force Urbania</option>
              <option>13 Seater Force Urbania</option>
              <option>17 Seater Force Urbania</option>
              <option>29 Seater Force Urbania</option>
              <option>25 Seater Tempo Traveller</option>
              <option>Other</option>
            </select>
           <input
  type="date"
  name="date"
  value={formData.date}
  onChange={handleChange}
   className="borderr"
  min={new Date().toISOString().split("T")[0]}
/>
          </div>

          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
             className="borderr"
          ></textarea>

          <button type="submit" className="send-btn">
            Send Message on WhatsApp
          </button>
        </form>
      </div>
    </section>


</>
  );
};

export default Enquiry;
